var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWhiteCheckMark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0142 5.88363V6.37734C12.0135 7.53458 11.6388 8.6606 10.9459 9.58747C10.253 10.5143 9.27904 11.1924 8.16929 11.5205C7.05955 11.8486 5.87347 11.8092 4.78795 11.4082C3.70243 11.0071 2.77562 10.2659 2.14577 9.29513C1.51591 8.32432 1.21674 7.17591 1.29288 6.02118C1.36903 4.86645 1.8164 3.76727 2.56828 2.88757C3.32016 2.00788 4.33626 1.39479 5.46504 1.13976C6.59383 0.884724 7.77481 1.00141 8.83186 1.4724M12.0142 2.08418L6.64771 7.456L5.03778 5.84607",
    stroke: "white",
    strokeWidth: 1.07329,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteCheckMark);
export default __webpack_public_path__ + "static/media/whiteCheckMark.1ea84e6f117d31c196ad7ea3b4682bf5.svg";
export { ForwardRef as ReactComponent };